import { ImageSeries } from "../api/generated";

export function seriesAndFrameToViewIndex(imageSeries: ImageSeries[], series: string, frame: number): number {
    const seriesIndex = imageSeries.findIndex(s => s.id === series);
    if (seriesIndex === -1) throw new Error(`Image series ${series} not found`);

    const frameIndex = imageSeries[seriesIndex].frames.findIndex(f => f === frame);
    if (frameIndex === -1) throw new Error(`Frame ${frame} not found in image series ${series}`);

    return imageSeries.slice(0, seriesIndex).reduce((sum, s) => sum + s.frames.length, 0) + frameIndex;
}

export function viewIndexToSeries(imageSeries: ImageSeries[], viewIndex: number): ImageSeries | null {
    let frameIndex = viewIndex;
    const foundSeries = imageSeries.find(series => {
        frameIndex -= series.frames.length;
        return frameIndex < 0;
    });
    return foundSeries || null;
}

export function viewIndexToSeriesId(imageSeries: ImageSeries[], viewIndex: number): string | null {
    return viewIndexToSeries(imageSeries, viewIndex)?.id || null;
}

export function viewIndexToFrame(imageSeries: ImageSeries[], viewIndex: number): number | null {
    let frameIndex = viewIndex;
    const foundSeries = imageSeries.find(series => {
        if (frameIndex < series.frames.length) {
            return true;
        }
        frameIndex -= series.frames.length;
        return false;
    });
    if (!foundSeries) return null;
    return foundSeries.frames[frameIndex];
}
